module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pretty_picture":"Pretty Picture","m31":"M31","m42":"M42","m45":"M45","m101":"M101","perseus_cluster":"Perseus Cluster"},"ja":{"pretty_picture":"星雲・近くの銀河など","m31":"M31","m42":"M42","m45":"M45","m101":"M101","perseus_cluster":"ペルセウス銀河団"}}')
  delete Component.options._Ctor
}
